export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13618.a5484375.jpg";